import { Icon } from '@chakra-ui/icons';

export const HamburgerRedIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="26px"
		height="18px"
		viewBox="0 0 26 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			width="16"
			height="2"
			fill={color}
		/>
		<rect
			y="8"
			width="26"
			height="2"
			fill={color}
		/>
		<rect
			y="16"
			width="26"
			height="2"
			fill={color}
		/>
	</Icon>
);
